import { AuthContext } from 'Context';
import { CATEGORY_IDS_TO_HIDE_ADD_EXISTING_BUTTON, ORDER_TYPES } from 'common/enums';

import AddButtonModel from './AddButtonModel';

class AddExistingButtonModel extends AddButtonModel {
  constructor(higherOrderInstance) {
    super(higherOrderInstance);

    this.id = 'li-category-add-existing-line-item-button_' + this._uuid;
  }

  get visible() {
    return Boolean(
      (this.masterOrder.orderType === ORDER_TYPES.REWRITE ||
        ([ORDER_TYPES.NEW_CUSTOMER, ORDER_TYPES.NEW_LOCATIONS].includes(this.masterOrder.orderType) &&
          AuthContext.model.isSalesOps)) &&
      !this._category.recurring &&
      super.visible &&
      !CATEGORY_IDS_TO_HIDE_ADD_EXISTING_BUTTON.includes(this._category.id)
    );
  }

  getDialogModel() {
    return this.masterOrder.addExistingLineItemDialog;
  }
}

export default AddExistingButtonModel;
